import React from "react";
import { Typography, Box } from "@mui/material";
import I18n from "i18next";

const sx = {
  component: {
    textAlign: "center",
    color: "darkBlue.c100",
    marginTop: "40px"
  }
};

export default function ThankYouComponent({ content }) {
  return (
    <>
      <Box sx={sx.component}>
        <img
          src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
          height={40}
          alt="logo"
        />
        <Typography variant="h4" sx={{ marginTop: "30px" }}>
          {I18n.t("common.thankYou")}
        </Typography>
        <Typography variant="h6" sx={{ marginTop: "30px" }}>
          {content}
        </Typography>
      </Box>
    </>
  );
}
